// ABOUTME: Welcome step for the DataSourceWizard.
// ABOUTME: Explains data sources and provides the entry point to connect Databricks.

import { Button } from '@/components/ui';

interface WelcomeStepProps {
  onNext: () => void;
  onCancel: () => void;
}

export function WelcomeStep({ onNext, onCancel }: WelcomeStepProps) {
  return (
    <div className="flex flex-col items-center text-center px-6 py-8">
      <div className="mb-6">
        <img
          src="/oleum-logo.png"
          alt="Oleum BI"
          className="w-16 h-16 object-contain"
        />
      </div>

      <h2 className="text-2xl font-semibold text-surface-900 mb-3">
        Connect Your Data
      </h2>

      <p className="text-surface-600 max-w-md mb-4">
        Connect your Databricks workspace to unlock powerful data investigations.
        Oleum BI will securely connect to your data and help you discover insights.
      </p>

      <div className="bg-surface-50 rounded-lg p-4 mb-8 max-w-md">
        <h3 className="text-sm font-medium text-surface-700 mb-2">
          What you'll need:
        </h3>
        <ul className="text-sm text-surface-600 text-left space-y-1">
          <li className="flex items-start gap-2">
            <span className="text-primary-500 mt-0.5">•</span>
            <span>Your Databricks workspace URL</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary-500 mt-0.5">•</span>
            <span>SQL Warehouse HTTP path</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary-500 mt-0.5">•</span>
            <span>Personal access token with read permissions</span>
          </li>
        </ul>
      </div>

      <div className="flex gap-3">
        <Button variant="ghost" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onNext}>
          Connect Databricks
        </Button>
      </div>
    </div>
  );
}
